import React from 'react';
import './ChallengesSection.css';

const challenges = [
  {
    title: 'Strategic Misalignment',
    description: 'People decisions disconnected from organizational mission, creating friction between talent strategy and business objectives.'
  },
  {
    title: 'Talent Competition',
    description: 'Competing for top talent against larger organizations with established employer brands and resources.'
  },
  {
    title: 'Limited Expertise',
    description: 'Lack of access to strategic HR expertise and enterprise-ready talent capabilities.'
  },
  {
    title: 'Reactive Decisions',
    description: 'Reactive people decisions that solve for today but create operational challenges tomorrow.'
  },
  {
    title: 'Compliance & Risk',
    description: 'Complex regulatory requirements and cultural risks without dedicated expertise to navigate them.'
  },
  {
    title: 'Resource Constraints',
    description: 'Operating without the budget, tools, or infrastructure that enables strategic talent management.'
  }
];

const ChallengesSection = () => {
  return (
    <section id="challenges" className="challenges-section">
      <div className="challenges-container">
        <div className="section-header">
          <div className="section-label">Challenges</div>
          <h2 className="section-title">The Challenges Growing Organizations Face</h2>
          <p className="section-subtitle">"Talent Issues are Business Issues."</p>
        </div>
        
        <div className="challenges-grid">
          {challenges.map((challenge, index) => (
            <div key={index} className="challenge-card">
              <h3 className="challenge-title">{challenge.title}</h3>
              <p className="challenge-description">{challenge.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChallengesSection;